export default __webpack_public_path__ + "static/media/fi_archive_picked.3b8ec988.svg";